(function($) {


	$.fn.jwplayer_render = function(objFunctionParams, objPlayerParams)
	{

		if(!objFunctionParams.hasOwnProperty('folder')){
			if(window.jwplayer_folder){ objFunctionParams.folder = window.jwplayer_folder; }
			else { objFunctionParams.folder = 'vod.plurotech/fof.plurotech/'; }
		}

		bolStream = true;
		if(objFunctionParams.no_stream === true ){
			bolStream = false;
			objPlayerParams.file = objFunctionParams.file;
		}

		if(bolStream){
			objFunctionParams.file = objFunctionParams.folder + objFunctionParams.file;
		}

		if(!objFunctionParams.hasOwnProperty('server')){
			if(window.jwplayer_server){ objFunctionParams.server = window.jwplayer_server; }
			else { objFunctionParams.server = 'http://rtsp01.hddn.com/play/_definst_/mp4:'; }
		}
		if(!objFunctionParams.hasOwnProperty('streamer')){
			if(window.jwplayer_streamer){ objFunctionParams.streamer = window.jwplayer_streamer; }
			else { objFunctionParams.streamer = 'rtmp://rtmp01.hddn.com/play'; }
		}
		if(!objFunctionParams.hasOwnProperty('playlist')){
		if(window.jwplayer_playlist){ objFunctionParams.playlist = window.jwplayer_playlist; }
			else { objFunctionParams.playlist = '/playlist.m3u8'; }
		}

		if( (navigator.userAgent.match(/iPhone/i)) )
		{

			$('#'+objFunctionParams.id).html('<a id="link_'+objFunctionParams.id+'" href="' + objFunctionParams.server + objFunctionParams.file + objFunctionParams.playlist + '"></a>');

			$('#link_'+objFunctionParams.id).css('display', 'block')
											.css('width', objPlayerParams.width + 'px')
											.css('height', objPlayerParams.height + 'px')
											.css('background', 'url(../..'+objPlayerParams.image+') no-repeat top left');

			var play_bt = 	$('<a/>', {
								'class': 'play_bt jw_play_bt',
								'href': objFunctionParams.server + objFunctionParams.file + objFunctionParams.playlist,
								'text': 'Play Video'
							});

			play_bt.appendTo('#link_'+objFunctionParams.id);
			play_bt.css('top', ($('#link_'+objFunctionParams.id).height() * 0.5) - (play_bt.height() * 0.5) );

		}
		else
		{

			/*objPlayer = jwplayer(objFunctionParams.id).setup( objPlayerParams ); */

			var JWParams = new Object();

			JWParams.file = objFunctionParams.file;
			/*
			if(objPlayerParams.hasOwnProperty('width')) {	JWParams.width = objPlayerParams.width; }
			if(objPlayerParams.hasOwnProperty('height')) {	JWParams.height = objPlayerParams.height; }
			if(objPlayerParams.hasOwnProperty('image')) { 	JWParams.image = objPlayerParams.image; }
			if(objPlayerParams.hasOwnProperty('autostart')) { 	JWParams.autostart = objPlayerParams.autostart; }
			if(objPlayerParams.hasOwnProperty('backcolor')) { 	JWParams.backcolor = objPlayerParams.backcolor; }
			*/
			JWParams = $.extend({}, JWParams, objPlayerParams);

			if(bolStream){
				JWParams.provider = 'rtmp';
				JWParams.streamer = objFunctionParams.streamer;
			}else{
				JWParams.provider = 'http';
			}

			JWParams.modes = [
					{
						type:'html5',
						config:{
							'file':objFunctionParams.server + objFunctionParams.file + objFunctionParams.playlist,
							'provider':'video'
							}
					},
					{
						type:'flash',
						src:objPlayerParams.flashplayer
					}
				];


			JWParams.primary = 'html5';

			jwplayer(objFunctionParams.id).setup(JWParams);

		}
	}

})(jQuery);